const DefaultSort = { field: 'updated_at', order: 'DESC' };

export default DefaultSort;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/DefaultSort.tsx